import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Validator from '../../../common/forms/Validator';
import Edit from '../../../common/forms/buttons/Edit';
import Cancel from '../../../common/forms/buttons/Cancel';
import Save from '../../../common/forms/buttons/Save';
import ErrorMessage from '../../../common/forms/ErrorMessage';
import Loader from '../../../common/ui/Loader';
import AddressInputAutoComplete from '../../../common/AddressInputAutoComplete';

const emptyLocation = {
  name: '',
  address: '',
  state: '',
  city: '',
  zip: '',
  address_coordinates: '',
  max_seats: null
};

export default class LocationItem extends Validator {
  static propTypes = {
    locationData: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      address: PropTypes.string,
      state: PropTypes.string,
      city: PropTypes.string,
      zip: PropTypes.string,
      address_coordinates: PropTypes.string,
      max_seats: PropTypes.number
    }),
    isCreatingLocation: PropTypes.bool,
    editOrientationLocation: PropTypes.func,
    createOrientationLocation: PropTypes.func,
    getOrientationLocationsList: PropTypes.func.isRequired
  };

  state = {
    isEditing: false,
    isLoading: false,
    ...emptyLocation,
    initialLocation: emptyLocation
  };

  validationRules = {
    name: { required: true },
    address: { required: true },
    state: { required: true },
    city: { required: true },
    zip: { required: true },
    address_coordinates: { required: true },
    max_seats: { required: true }
  };

  static getDerivedStateFromProps = (props, state) => {
    if (props.locationData && (props.locationData !== state.initialLocation)) {
      return {
        ...props.locationData,
        initialLocation: props.locationData
      };
    }
    return null;
  };

  editLocation = () => {
    this.setState({
      isEditing: true
    });
  };

  cancelEditing = () => {
    this.setState({
      isEditing: false,
      ...this.state.initialLocation
    });
    this._resetErrors();
  };

  handleChangeLocation = event => {
    const { name } = event.target;
    let { value } = event.target;
    if (name === 'max_seats') {
      value = value === '' ? value : parseInt(value, 10);
    }
    this.setState({ [name]: value });
  };

  handleChangeAddress = addressInfo => {
    const { address, city, state, zip, address_coordinates } = addressInfo;
    this.setState({
      address,
      city,
      state,
      zip,
      address_coordinates
    });
  };

  closeLocationCreation = () => {
    this.setState({
      ...emptyLocation
    });
    this.props.closeNewLocationForm();
  };

  handleSubmit = event => {
    event.preventDefault();
    if (this.validate(this.validationRules)) {
      this.setState({
        isLoading: true
      });
      const { name, address, state, city, zip, address_coordinates, max_seats, initialLocation } = this.state;
      const locationData = { address, state, city, zip, address_coordinates, max_seats };
      if (name !== initialLocation.name) {
        locationData.name = name;
      }
      const submitMethod = this.state.isEditing ? this.submitEditing : this.createLocation;
      submitMethod(locationData);
    }
  };

  submitEditing = locationData => {
    this.props.editOrientationLocation(this.state.id, locationData).then(response => {
      this.setState({
        isLoading: false,
        isEditing: false
      });
      if (response) {
        this.props.getOrientationLocationsList();
      } else {
        this.setState({
          ...this.state.initialLocation
        });
      }
    });
  };

  createLocation = locationData => {
    const { createOrientationLocation, getOrientationLocationsList } = this.props;
    createOrientationLocation(locationData).then(data => {
      this.setState({
        isLoading: false
      });
      if (data) {
        this.closeLocationCreation();
        getOrientationLocationsList();
      }
    });
  };

  render () {
    const { isEditing, isLoading, name, address, state, city, zip, address_coordinates, max_seats } = this.state;
    const { isCreatingLocation } = this.props;
    const isEditingMode = isEditing || isCreatingLocation;
    const addressInfo = {
      address,
      state,
      city,
      zip,
      address_coordinates
    };
    const errors = this.validationErrors;
    const addressErrorMessage = (errors.address || errors.state || errors.city || errors.zip || errors.address_coordinates) ? 'Not valid' : '';
    return (
      <div className='mb-3 col-12 col-md-6 col-xl-4'>
        <form className='item-wrapper location-list-item' onSubmit={this.handleSubmit}>
          { isLoading ? (
            <Loader />
          ) : (
            <Fragment>
              <div className='location-header-wrapper'>
                <div className='d-flex justify-content-between align-items-center'>
                  { isEditingMode ? (
                    <div className='location-name-input-wrapper'>
                      <input
                        className='input'
                        type='text'
                        name='name'
                        value={name || ''}
                        placeholder='Name'
                        onChange={this.handleChangeLocation}
                      />
                    </div>
                  ) : (
                    <h4>{name}</h4>
                  )}
                  <div className='ml-1'>
                    { isCreatingLocation ? (
                      <Cancel onClick={this.closeLocationCreation} />
                    ) : isEditing ? (
                      <div className='d-flex'>
                        <Cancel onClick={this.cancelEditing} />
                        <Save />
                      </div>
                    ) : (
                      <Edit onClick={this.editLocation} />
                    )}
                  </div>
                </div>
                <ErrorMessage errorText={errors.name} />
              </div>
              <AddressInputAutoComplete
                noLabel
                isDisabled={!isEditingMode}
                addressInfo={addressInfo}
                handleAddressChange={this.handleChangeAddress}
                errorMessage={addressErrorMessage}
              />
              <div>
                Max seats:
                { isEditingMode ? (
                  <input
                    className='input input-max-seats'
                    type='number'
                    min='1'
                    name='max_seats'
                    value={max_seats || ''}
                    onChange={this.handleChangeLocation}
                  />
                ) : (
                  <span className='ml-2'>{max_seats}</span>
                )}
                <ErrorMessage errorText={errors.max_seats} />
              </div>
              {isCreatingLocation && (
                <button type='submit' className='mt-3 w-100 button button-primary'>Add Location</button>
              )}
            </Fragment>
          )}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/orientations/LocationsList/LocationItem.js